import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('page.inspection');
import { OnInit, ChangeDetectorRef as CDR } from '@angular/core';
import { Service } from "src/libs/portal/season/service";

declare let wiz: any;

@Component({
    selector: 'wiz-page-inspection',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/page.inspection/view.scss */
:host {
  display: block;
  height: 100vh;
  background-color: #F8F9FA;
}

.inspection-page {
  font-family: "Pretendard", sans-serif;
  display: flex;
  flex-direction: column;
  height: 100%;
  overflow: hidden;
}

.header-container {
  background-color: #FFFFFF;
  padding: 10px 20px;
  border-bottom: 1px solid #E3E3E3;
  z-index: 10;
  flex-shrink: 0;
}

.top-app-bar {
  display: flex;
  align-items: center;
  gap: 12px;
  width: 100%;
  max-width: 1200px;
  margin: 0 auto;
}
.top-app-bar .nav-btn, .top-app-bar .action-btn {
  width: 44px;
  height: 44px;
  border-radius: 22px;
  border: none;
  background: transparent;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #444746;
  cursor: pointer;
  flex-shrink: 0;
}
.top-app-bar .nav-btn:hover, .top-app-bar .action-btn:hover {
  background-color: #F1F3F4;
}
.top-app-bar .nav-btn:active, .top-app-bar .action-btn:active {
  background-color: #E3E3E3;
}
.top-app-bar .nav-btn i, .top-app-bar .action-btn i {
  font-size: 18px;
}

.header-main-row {
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
}

.filter-group {
  display: flex;
  gap: 6px;
  overflow-x: auto;
}
.filter-group::-webkit-scrollbar {
  display: none;
}
.filter-group .m3-chip {
  height: 34px;
  padding: 0 14px;
  border-radius: 10px;
  border: 1px solid #C4C7C5;
  background: transparent;
  display: flex;
  align-items: center;
  gap: 6px;
  white-space: nowrap;
  cursor: pointer;
  transition: all 0.2s;
}
.filter-group .m3-chip span {
  font-size: 13px;
  font-weight: 700;
  color: #444746;
}
.filter-group .m3-chip .dot {
  width: 8px;
  height: 8px;
  border-radius: 50%;
}
.filter-group .m3-chip .dot.ongoing {
  background-color: #1E8E3E;
}
.filter-group .m3-chip .dot.planned {
  background-color: #F9AB00;
}
.filter-group .m3-chip .dot.completed {
  background-color: #1A73E8;
}
.filter-group .m3-chip.active {
  background-color: #D3E3FD;
  border-color: #A8C7FA;
}
.filter-group .m3-chip.active span {
  color: #041E49;
}
.filter-group .m3-chip:hover:not(.active) {
  background-color: #F8F9FA;
  border-color: #A8C7FA;
}

.search-group {
  display: flex;
  align-items: center;
  background-color: #F1F3F4;
  height: 40px;
  border-radius: 20px;
  padding: 0 16px;
  gap: 10px;
  width: 100%;
  max-width: 280px;
  transition: all 0.2s;
  border: 1px solid transparent;
}
.search-group:focus-within {
  background-color: #FFFFFF;
  border-color: #0B57D0;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.1);
}
.search-group .search-icon {
  color: #5F6368;
  font-size: 14px;
}
.search-group input {
  width: 100%;
  background: transparent;
  border: none;
  outline: none;
  font-size: 14px;
  color: #1F1F1F;
  font-weight: 500;
}
.search-group input::placeholder {
  color: #70757A;
}

.scaffold-content {
  flex: 1;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  padding: 16px 20px;
  width: 100%;
  max-width: 1200px;
  margin: 0 auto;
}

.content-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 12px;
  flex-shrink: 0;
}
.content-header .labels {
  display: flex;
  align-items: baseline;
  gap: 12px;
}
.content-header .title-large {
  font-size: 20px;
  font-weight: 800;
  color: #1F1F1F;
  margin: 0;
}
.content-header .body-small {
  font-size: 13px;
  color: #70757A;
  font-weight: 500;
}
.content-header .sort-box {
  display: flex;
  align-items: center;
  gap: 6px;
  color: #0B57D0;
  font-size: 13px;
  font-weight: 700;
}
.content-header .sort-box select {
  border: none;
  background: transparent;
  color: inherit;
  font-family: inherit;
  font-weight: inherit;
  outline: none;
  cursor: pointer;
}

.project-list {
  flex: 1;
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  grid-template-rows: repeat(3, minmax(190px, 1fr));
  gap: 16px;
  min-height: 0;
  overflow-y: auto;
  align-content: stretch;
}

.m3-card {
  background-color: #FFFFFF;
  border-radius: 16px;
  display: flex;
  flex-direction: row;
  cursor: pointer;
  border: 1px solid #E8EAED;
  transition: all 0.15s ease-out;
  overflow: hidden;
  min-height: 190px;
}
.m3-card:hover {
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.08);
  border-color: #D3E3FD;
}
.m3-card:active {
  transform: scale(0.99);
}
.m3-card .status-bar {
  width: 5px;
  flex-shrink: 0;
  border-radius: 16px 0 0 16px;
}
.m3-card.ongoing .status-bar {
  background-color: #1E8E3E;
}
.m3-card.planned .status-bar {
  background-color: #F9AB00;
}
.m3-card.completed .status-bar {
  background-color: #1A73E8;
}

.card-body {
  flex: 1;
  padding: 20px 22px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  gap: 12px;
  min-width: 0;
}

.card-top {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
}

.card-title-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  gap: 12px;
}
.card-title-row .title-medium {
  font-size: 17px;
  font-weight: 700;
  color: #1F1F1F;
  margin: 0;
  line-height: 1.3;
  flex: 1;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.status-badge {
  padding: 3px 10px;
  border-radius: 6px;
  font-size: 11px;
  font-weight: 800;
  white-space: nowrap;
  flex-shrink: 0;
}
.status-badge.ongoing {
  background-color: #E6F4EA;
  color: #137333;
}
.status-badge.planned {
  background-color: #FEF7E0;
  color: #B05E00;
}
.status-badge.completed {
  background-color: #E8F0FE;
  color: #1967D2;
}

.card-info {
  display: flex;
  flex-direction: column;
  gap: 4px;
}
.card-info .info-item {
  display: flex;
  align-items: center;
  gap: 6px;
  font-size: 13px;
  color: #5F6368;
}
.card-info .info-item i {
  width: 14px;
  font-size: 12px;
  color: #9AA0A6;
  text-align: center;
}

.card-action {
  display: flex;
  align-items: center;
  gap: 6px;
  color: #0B57D0;
  font-size: 13px;
  font-weight: 700;
}
.card-action i {
  font-size: 11px;
}

.pagination-bar {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 16px;
  padding: 14px 0 6px;
  flex-shrink: 0;
}

.page-btn {
  width: 48px;
  height: 48px;
  border-radius: 50%;
  border: 1px solid #E0E0E0;
  background: #FFFFFF;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  color: #1F1F1F;
  transition: all 0.15s;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.06);
}
.page-btn i {
  font-size: 16px;
}
.page-btn:hover:not(:disabled) {
  background-color: #E8F0FE;
  border-color: #0B57D0;
  color: #0B57D0;
}
.page-btn:active:not(:disabled) {
  transform: scale(0.95);
}
.page-btn:disabled {
  opacity: 0.3;
  cursor: not-allowed;
}

.page-indicators {
  display: flex;
  gap: 8px;
}

.page-dot {
  width: 36px;
  height: 36px;
  border-radius: 50%;
  border: none;
  background: transparent;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 14px;
  font-weight: 700;
  color: #5F6368;
  cursor: pointer;
  transition: all 0.15s;
}
.page-dot:hover {
  background-color: #F1F3F4;
}
.page-dot.active {
  background-color: #0B57D0;
  color: #FFFFFF;
}

.loader-container {
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}
.loader-container p {
  margin-top: 16px;
  font-size: 14px;
  color: #5F6368;
  font-weight: 600;
}

.google-spinner {
  width: 40px;
  height: 40px;
  border: 3px solid #E8EAED;
  border-top-color: #0B57D0;
  border-radius: 50%;
  animation: spin 0.9s ease-in-out infinite;
}

.empty-view {
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}
.empty-view .empty-icon {
  width: 80px;
  height: 80px;
  margin-bottom: 16px;
  background: #F1F3F4;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
}
.empty-view .empty-icon i {
  font-size: 32px;
  color: #9AA0A6;
}
.empty-view h3 {
  font-size: 18px;
  color: #3C4043;
  font-weight: 700;
  margin: 0 0 6px;
}
.empty-view p {
  font-size: 13px;
  color: #5F6368;
  margin: 0;
}

@keyframes spin {
  to {
    transform: rotate(360deg);
  }
}
@media (min-width: 768px) and (max-width: 1024px) {
  .header-container {
    padding: 12px 24px;
  }
  .top-app-bar .nav-btn, .top-app-bar .action-btn {
    width: 48px;
    height: 48px;
  }
  .top-app-bar .nav-btn i, .top-app-bar .action-btn i {
    font-size: 20px;
  }
  .filter-group .m3-chip {
    height: 40px;
    padding: 0 18px;
  }
  .filter-group .m3-chip span {
    font-size: 14px;
  }
  .search-group {
    height: 46px;
    border-radius: 23px;
    max-width: 300px;
  }
  .search-group input {
    font-size: 15px;
  }
  .scaffold-content {
    padding: 16px 24px;
  }
  .content-header {
    margin-bottom: 14px;
  }
  .content-header .title-large {
    font-size: 22px;
  }
  .content-header .body-small {
    font-size: 14px;
  }
  .project-list {
    grid-template-columns: repeat(2, minmax(0, 1fr));
    gap: 10px;
  }
  .m3-card {
    border-radius: 18px;
  }
  .m3-card:active {
    transform: scale(0.99);
  }
  .card-body {
    padding: 16px 20px;
    gap: 10px;
  }
  .card-title-row .title-medium {
    font-size: 16px;
  }
  .status-badge {
    padding: 4px 12px;
    font-size: 12px;
  }
  .card-info {
    gap: 4px;
  }
  .card-info .info-item {
    font-size: 13px;
  }
  .card-info .info-item i {
    font-size: 12px;
  }
  .card-action {
    font-size: 14px;
  }
  .pagination-bar {
    padding: 16px 0 8px;
    gap: 20px;
  }
  .page-btn {
    width: 52px;
    height: 52px;
  }
  .page-btn i {
    font-size: 18px;
  }
  .page-dot {
    width: 40px;
    height: 40px;
    font-size: 15px;
  }
}
@media (min-width: 600px) and (max-width: 767px) {
  .header-main-row {
    flex-direction: column;
    align-items: stretch;
    gap: 10px;
  }
  .search-group {
    max-width: 100%;
    height: 44px;
  }
  .filter-group {
    justify-content: center;
  }
  .filter-group .m3-chip {
    height: 38px;
    padding: 0 16px;
  }
  .scaffold-content {
    padding: 14px 20px;
  }
  .content-header {
    margin-bottom: 10px;
  }
  .content-header .title-large {
    font-size: 20px;
  }
  .project-list {
    grid-template-columns: repeat(2, 1fr);
    grid-template-rows: none;
    grid-auto-rows: minmax(160px, auto);
    gap: 10px;
  }
  .m3-card {
    border-radius: 14px;
    min-height: 160px;
  }
  .card-body {
    padding: 12px 16px;
    gap: 6px;
  }
  .card-title-row .title-medium {
    font-size: 15px;
  }
  .card-info {
    gap: 4px;
  }
  .card-info .info-item {
    font-size: 12px;
  }
  .pagination-bar {
    padding: 12px 0 4px;
  }
}
@media (max-width: 599px) {
  .header-container {
    padding: 8px 14px;
  }
  .header-main-row {
    flex-direction: column;
    align-items: stretch;
    gap: 8px;
  }
  .search-group {
    max-width: 100%;
  }
  .scaffold-content {
    padding: 12px 14px;
  }
  .content-header {
    margin-bottom: 8px;
  }
  .content-header .title-large {
    font-size: 18px;
  }
  .content-header .labels {
    flex-direction: column;
    gap: 2px;
  }
  .project-list {
    grid-template-columns: 1fr;
    grid-template-rows: none;
    grid-auto-rows: minmax(150px, auto);
    gap: 8px;
  }
  .m3-card {
    border-radius: 12px;
    min-height: 150px;
  }
  .card-body {
    padding: 12px 14px;
    gap: 6px;
  }
  .card-title-row .title-medium {
    font-size: 15px;
  }
  .card-info {
    flex-direction: column;
    gap: 4px;
  }
  .card-action {
    font-size: 12px;
  }
  .pagination-bar {
    padding: 10px 0 4px;
  }
  .page-btn {
    width: 44px;
    height: 44px;
  }
  .page-dot {
    width: 32px;
    height: 32px;
    font-size: 13px;
  }
}.card-side-actions{display:flex;flex-direction:column;align-items:flex-end;gap:6px;flex-shrink:0}.share-button{border:1px solid #A8C7FA;background:#E8F0FE;color:#0B57D0;border-radius:8px;padding:5px 8px;display:flex;align-items:center;gap:5px;font-size:11px;font-weight:800;cursor:pointer;white-space:nowrap}.share-button:hover{background:#D3E3FD;border-color:#0B57D0}.share-button small{font-size:10px;color:#5F6368}.shared-label{display:flex;align-items:center;gap:4px;color:#5F6368;font-size:11px;font-weight:700}.share-modal-backdrop{position:fixed;inset:0;z-index:1000;background:rgba(15,23,42,.55);display:flex;align-items:center;justify-content:center;padding:20px;cursor:default}.share-modal{width:min(520px,100%);max-height:min(720px,90vh);background:#fff;border-radius:20px;box-shadow:0 24px 64px rgba(15,23,42,.3);display:flex;flex-direction:column;overflow:hidden;text-align:left}.share-modal-header{display:flex;justify-content:space-between;gap:16px;padding:22px 24px 16px;border-bottom:1px solid #E8EAED}.share-modal-header h3{margin:3px 0 6px;font-size:19px;color:#1F1F1F}.share-modal-header p{margin:0;color:#5F6368;font-size:12px}.share-modal-eyebrow{color:#0B57D0!important;font-weight:800!important}.share-modal-close{width:36px;height:36px;border:0;border-radius:50%;background:#F1F3F4;color:#5F6368;cursor:pointer}.share-modal-toolbar{display:flex;align-items:center;gap:12px;padding:14px 24px}.share-search{flex:1;height:40px;border-radius:12px;background:#F1F3F4;display:flex;align-items:center;gap:9px;padding:0 13px;color:#70757A}.share-search input{width:100%;border:0;outline:0;background:transparent;font-size:13px}.share-modal-toolbar strong{color:#0B57D0;font-size:13px}.share-user-list{min-height:180px;max-height:340px;overflow-y:auto;padding:0 16px 8px}.share-user-option{width:100%;border:1px solid transparent;background:#fff;border-radius:12px;padding:11px 12px;display:flex;align-items:center;gap:11px;text-align:left;cursor:pointer;color:#9AA0A6}.share-user-option:hover{background:#F8F9FA}.share-user-option.selected{background:#E8F0FE;border-color:#A8C7FA;color:#0B57D0}.share-user-avatar{width:36px;height:36px;border-radius:50%;background:#F1F3F4;color:#3C4043;display:flex;align-items:center;justify-content:center;font-weight:800;flex-shrink:0}.share-user-copy{display:flex;flex-direction:column;gap:3px;min-width:0;flex:1}.share-user-copy b{color:#1F1F1F;font-size:13px}.share-user-copy small{color:#70757A;font-size:11px;white-space:nowrap;overflow:hidden;text-overflow:ellipsis}.share-modal-loading,.share-modal-empty{min-height:180px;display:flex;align-items:center;justify-content:center;gap:8px;color:#70757A;font-size:13px}.share-modal-error{margin:0 24px 10px;color:#B3261E;font-size:12px;display:flex;align-items:center;gap:6px}.share-modal-footer{display:flex;justify-content:flex-end;gap:8px;padding:14px 24px 20px;border-top:1px solid #E8EAED}.share-cancel-button,.share-save-button{border:0;border-radius:10px;padding:10px 16px;font-size:13px;font-weight:800;cursor:pointer}.share-cancel-button{background:#F1F3F4;color:#3C4043}.share-save-button{background:#0B57D0;color:#fff;display:flex;align-items:center;gap:7px}.share-save-button:disabled,.share-cancel-button:disabled{opacity:.5;cursor:not-allowed}@media(max-width:599px){.card-title-row{align-items:flex-start}.share-modal-backdrop{padding:12px}.share-modal{max-height:92vh}.share-modal-header,.share-modal-toolbar,.share-modal-footer{padding-left:16px;padding-right:16px}.share-user-list{padding-left:8px;padding-right:8px}}`],
})
export class PageInspectionComponent implements OnInit {
    public projects: any[] = [];
    public displayProjects: any[] = [];
    public loading: boolean = true;
    public syncingProjects: boolean = false;
    private detailSyncEnabled: boolean = false;
    private detailSyncRunning: boolean = false;
    private detailSyncActiveId: string = '';
    private detailSyncPendingIds: string[] = [];
    private detailSyncPendingIdSet: Set<string> = new Set<string>();
    private detailSyncCompletedIds: Set<string> = new Set<string>();

    // Filter & Sort States
    public filterTab: string = 'ongoing';
    public searchText: string = '';
    public sortType: string = 'project_no_desc';

    // Pagination
    public pageSize: number = 6;
    public currentPage: number = 1;

    constructor(@Inject( Service)         public service: Service,@Inject( CDR    )         public ref: CDR    ) { }

    public async ngOnInit() {
        await this.service.init(this);
        await this.loadProjects(true, false);
        this.detailSyncEnabled = true;
        this.enqueueVisibleProjectDetailSync();
        this.loadProjects(false, true);
    }

    public async loadProjects(showLoading: boolean = true, manualSync: boolean = false) {
        if (manualSync) {
            if (this.syncingProjects) return;
            this.syncingProjects = true;
        }
        if (showLoading) {
            this.loading = true;
            await this.service.render();
        }

        try {
            const { code, data } = await wiz.call("init", { sync_projects: manualSync ? "true" : "false" }, { timeout: 60000 });
            if (code === 200) {
                this.projects = data.projects;
                this.onFilter();
            }
        } catch (e) {
            console.error(e);
        } finally {
            if (manualSync) {
                this.detailSyncEnabled = true;
                this.enqueueVisibleProjectDetailSync();
                this.syncingProjects = false;
            }
            if (showLoading) this.loading = false;
            await this.service.render();
        }
    }

    public async refreshProjects() {
        this.searchText = "";
        this.filterTab = "ongoing";
        this.currentPage = 1;
        this.detailSyncCompletedIds.clear();
        this.detailSyncEnabled = true;
        this.onFilter();
        await this.loadProjects(true, true);
    }

    public setFilter(tab: string) {
        this.filterTab = tab;
        this.currentPage = 1;
        this.onFilter();
    }

    public onFilter() {
        let filtered = [...this.projects];

        if (this.filterTab !== 'all') {
            filtered = filtered.filter(p => p.status_color === this.filterTab);
        }

        if (this.searchText) {
            const query = this.searchText.toLowerCase().trim();
            filtered = filtered.filter(p =>
                p.title.toLowerCase().includes(query) ||
                (p.project_no && p.project_no.toString().toLowerCase().includes(query))
            );
        }

        filtered.sort((a, b) => {
            if (this.sortType === 'title') return a.title.localeCompare(b.title);
            return String(b.project_no || '').localeCompare(
                String(a.project_no || ''),
                'ko',
                { numeric: true, sensitivity: 'base' }
            );
        });

        this.displayProjects = filtered;
        this.currentPage = 1;
        this.enqueueVisibleProjectDetailSync();
        this.service.render();
    }

    private enqueueVisibleProjectDetailSync() {
        if (!this.detailSyncEnabled) return;

        for (const project of this.displayProjects) {
            const projectId = String(project.id || '');
            if (!projectId || project.shared_with_me) continue;
            if (this.detailSyncCompletedIds.has(projectId)) continue;
            if (this.detailSyncActiveId === projectId) continue;
            if (this.detailSyncPendingIdSet.has(projectId)) continue;
            this.detailSyncPendingIds.push(projectId);
            this.detailSyncPendingIdSet.add(projectId);
        }

        if (!this.detailSyncRunning && this.detailSyncPendingIds.length > 0) {
            this.runProjectDetailSync();
        }
    }

    private async runProjectDetailSync() {
        if (this.detailSyncRunning) return;
        this.detailSyncRunning = true;
        try {
            while (this.detailSyncPendingIds.length > 0) {
                const projectId = this.detailSyncPendingIds.shift();
                this.detailSyncPendingIdSet.delete(projectId as string);
                if (!projectId) continue;
                this.detailSyncActiveId = projectId;
                try {
                    const { code, data, message } = await wiz.call('init', {
                        detail_project_id: projectId
                    }, { timeout: 120000, forceServer: true });
                    if (code !== 200 || !data) {
                        throw new Error(message || '용역 상세 동기화 실패');
                    }
                    const project = this.projects.find(item => String(item.id) === projectId);
                    if (project) Object.assign(project, data);
                    await this.service.render();
                } catch (error) {
                    console.warn(`Project detail sync failed: ${projectId}`, error);
                } finally {
                    this.detailSyncCompletedIds.add(projectId);
                    this.detailSyncActiveId = '';
                }
            }
        } finally {
            this.detailSyncRunning = false;
            if (this.detailSyncPendingIds.length > 0) this.runProjectDetailSync();
        }
    }

    // Pagination
    public get totalPages(): number {
        return Math.max(1, Math.ceil(this.displayProjects.length / this.pageSize));
    }

    public get paginatedProjects(): any[] {
        const start = (this.currentPage - 1) * this.pageSize;
        return this.displayProjects.slice(start, start + this.pageSize);
    }

    public get pageStart(): number {
        if (this.displayProjects.length === 0) return 0;
        return (this.currentPage - 1) * this.pageSize + 1;
    }

    public get pageEnd(): number {
        return Math.min(this.currentPage * this.pageSize, this.displayProjects.length);
    }

    public nextPage() {
        if (this.currentPage < this.totalPages) {
            this.currentPage++;
            this.service.render();
        }
    }

    public prevPage() {
        if (this.currentPage > 1) {
            this.currentPage--;
            this.service.render();
        }
    }

    public goToPage(page: number) {
        if (page >= 1 && page <= this.totalPages) {
            this.currentPage = page;
            this.service.render();
        }
    }

    public get pageNumbers(): number[] {
        const pages: number[] = [];
        for (let i = 1; i <= this.totalPages; i++) {
            pages.push(i);
        }
        return pages;
    }

    public formatDate(dateStr: string): string {
        if (!dateStr) return '';
        return dateStr.split(' ')[0];
    }

    public getStatusLabel(color: string): string {
        if (color === 'ongoing') return '진행중';
        if (color === 'planned') return '예정';
        if (color === 'completed') return '완료';
        return '';
    }

    public async selectProject(project: any) {
        await this.service.href(`/project/detail/${project.id}`);
    }

    public async goBack() {
        await this.service.href('/home');
    }

    public shareModalOpen: boolean = false;
    public shareProject: any = null;
    public shareCandidates: any[] = [];
    public shareSelectedIds: string[] = [];
    public shareSearchText: string = '';
    public shareLoading: boolean = false;
    public shareSaving: boolean = false;
    public shareError: string = '';
    public maxShares: number = 3;

    public isShareOnline(): boolean {
        return !wiz.offline || wiz.offline.isOnline();
    }

    public get filteredShareCandidates(): any[] {
        const query = this.shareSearchText.toLowerCase().trim();
        if (!query) return this.shareCandidates;
        return this.shareCandidates.filter(user =>
            [user.name, user.email, user.department]
                .some(value => String(value || '').toLowerCase().includes(query))
        );
    }

    public isShareSelected(userId: string): boolean {
        return this.shareSelectedIds.includes(String(userId));
    }

    public async openShareModal(event: Event, project: any) {
        event?.stopPropagation();
        this.shareModalOpen = true;
        this.shareProject = project;
        this.shareCandidates = [];
        this.shareSelectedIds = [];
        this.shareSearchText = '';
        this.shareLoading = true;
        this.shareSaving = false;
        this.shareError = '';
        await this.service.render();

        if (!this.isShareOnline()) {
            this.shareLoading = false;
            this.shareError = '프로젝트 공유는 온라인 상태에서만 사용할 수 있습니다.';
            await this.service.render();
            return;
        }

        try {
            const { code, data, message } = await wiz.call('init', {
                share_action: 'candidates',
                project_id: project.id
            });
            if (code !== 200 || !data || !Array.isArray(data.users)) {
                throw new Error(message || (typeof data === 'string' ? data : '공유 대상을 불러오지 못했습니다.'));
            }
            this.shareCandidates = data.users;
            this.shareSelectedIds = (data.selected_user_ids || []).map((id: any) => String(id));
            this.maxShares = Number(data.max_shares) || 3;
        } catch (error: any) {
            this.shareError = error?.message || '공유 대상을 불러오지 못했습니다.';
        } finally {
            this.shareLoading = false;
            await this.service.render();
        }
    }

    public async closeShareModal() {
        if (this.shareSaving) return;
        this.shareModalOpen = false;
        this.shareProject = null;
        this.shareCandidates = [];
        this.shareSelectedIds = [];
        this.shareSearchText = '';
        this.shareError = '';
        await this.service.render();
    }

    public async toggleShareUser(user: any) {
        const userId = String(user.id);
        const selectedIndex = this.shareSelectedIds.indexOf(userId);
        if (selectedIndex >= 0) {
            this.shareSelectedIds = this.shareSelectedIds.filter(id => id !== userId);
            this.shareError = '';
        } else {
            if (this.shareSelectedIds.length >= this.maxShares) {
                this.shareError = '프로젝트는 최대 3명에게만 공유할 수 있습니다.';
                await this.service.render();
                return;
            }
            this.shareSelectedIds = [...this.shareSelectedIds, userId];
            this.shareError = '';
        }
        await this.service.render();
    }

    public async saveProjectShares() {
        if (!this.shareProject || this.shareSaving) return;
        if (!this.isShareOnline()) {
            this.shareError = '프로젝트 공유는 온라인 상태에서만 사용할 수 있습니다.';
            await this.service.render();
            return;
        }

        this.shareSaving = true;
        this.shareError = '';
        await this.service.render();
        try {
            const { code, data, message } = await wiz.call('init', {
                share_action: 'save',
                project_id: this.shareProject.id,
                user_ids: JSON.stringify(this.shareSelectedIds)
            });
            if (code !== 200 || !data || !Array.isArray(data.selected_user_ids)) {
                throw new Error(message || (typeof data === 'string' ? data : '공유 정보를 저장하지 못했습니다.'));
            }
            const shareCount = Number(data.share_count) || 0;
            this.shareProject.share_count = shareCount;
            const listProject = this.projects.find(project => String(project.id) === String(this.shareProject.id));
            if (listProject) listProject.share_count = shareCount;
            this.shareModalOpen = false;
            this.shareProject = null;
            this.shareCandidates = [];
            this.shareSelectedIds = [];
        } catch (error: any) {
            this.shareError = error?.message || '공유 정보를 저장하지 못했습니다.';
        } finally {
            this.shareSaving = false;
            await this.service.render();
        }
    }
}

export default PageInspectionComponent;